module.exports = __webpack_public_path__ + "img/save-print-box-en.9c4ebbf6.png";